import * as CookieConsent from "vanilla-cookieconsent"
import { disableAnalytics, enableAnalytics } from "../analytics/posthog"

const CONSENT_REVISION = 1

function syncAnalyticsConsent() {
  if (CookieConsent.acceptedCategory("analytics")) {
    enableAnalytics()
  } else {
    disableAnalytics()
  }
}

export function initCookieConsent() {
  return CookieConsent.run({
    mode: "opt-in",
    revision: CONSENT_REVISION,
    cookie: {
      name: "buildsolution_consent",
      expiresAfterDays: 182,
      sameSite: "Lax",
    },
    guiOptions: {
      consentModal: {
        layout: "bar inline",
        position: "bottom",
        equalWeightButtons: true,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
      },
    },
    onConsent: syncAnalyticsConsent,
    onChange: syncAnalyticsConsent,
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false,
      },
    },
    language: {
      default: "en",
      autoDetect: "document",
      translations: {
        en: {
          consentModal: {
            label: "Privacy choices",
            title: "A note about analytics",
            description:
              "We use necessary storage to remember your preferences. With your permission, we also collect analytics data to understand which content is useful and improve the site.",
            acceptAllBtn: "Allow analytics",
            acceptNecessaryBtn: "Necessary only",
            footer: '<a href="/policy/privacy-en/">Read the privacy policy</a>',
          },
          preferencesModal: {
            title: "Privacy settings",
            acceptAllBtn: "Allow analytics",
            acceptNecessaryBtn: "Necessary only",
            savePreferencesBtn: "Save settings",
            closeIconLabel: "Close privacy settings",
            sections: [
              {
                description:
                  "Choose whether we may collect analytics data. You can change this choice at any time.",
              },
              {
                title: "Necessary",
                description:
                  "Stores your privacy and display preferences. This is always active.",
                linkedCategory: "necessary",
              },
              {
                title: "Analytics",
                description:
                  "Measures page views and selected interactions so we can understand how the site is used. This data is not used for advertising.",
                linkedCategory: "analytics",
              },
              {
                title: "More information",
                description:
                  'Details are available in the <a href="/policy/privacy-en/">privacy policy</a>.',
              },
            ],
          },
        },
        pl: {
          consentModal: {
            label: "Wybór ustawień prywatności",
            title: "Informacja o danych analitycznych",
            description:
              "Używamy niezbędnego zapisu, aby zapamiętać Twoje ustawienia. Za Twoją zgodą zbieramy również dane analityczne, które pomagają nam ocenić przydatność treści i ulepszać stronę.",
            acceptAllBtn: "Zezwól na analitykę",
            acceptNecessaryBtn: "Tylko niezbędne",
            footer:
              '<a href="/policy/privacy-pl/">Przeczytaj politykę prywatności</a>',
          },
          preferencesModal: {
            title: "Ustawienia prywatności",
            acceptAllBtn: "Zezwól na analitykę",
            acceptNecessaryBtn: "Tylko niezbędne",
            savePreferencesBtn: "Zapisz ustawienia",
            closeIconLabel: "Zamknij ustawienia prywatności",
            sections: [
              {
                description:
                  "Zdecyduj, czy możemy zbierać dane analityczne. Ten wybór możesz zmienić w dowolnym momencie.",
              },
              {
                title: "Niezbędne",
                description:
                  "Zapamiętują ustawienia prywatności i wyglądu strony. Ta kategoria jest zawsze aktywna.",
                linkedCategory: "necessary",
              },
              {
                title: "Analityka",
                description:
                  "Mierzy odsłony i wybrane interakcje, aby pomóc nam zrozumieć sposób korzystania ze strony. Dane nie są wykorzystywane do reklam.",
                linkedCategory: "analytics",
              },
              {
                title: "Więcej informacji",
                description:
                  'Szczegóły znajdziesz w <a href="/policy/privacy-pl/">polityce prywatności</a>.',
              },
            ],
          },
        },
      },
    },
  })
}

export function showCookiePreferences() {
  CookieConsent.showPreferences()
}
